export const SUBMIT_FORGOT_PASSWORD_FORM_START =
  "SUBMIT_FORGOT_PASSWORD_FORM_START";
export const SUBMIT_FORGOT_PASSWORD_FORM_SUCCESS =
  "SUBMIT_FORGOT_PASSWORD_FORM_SUCCESS";
export const SUBMIT_FORGOT_PASSWORD_FORM_FAILURE =
  "SUBMIT_FORGOT_PASSWORD_FORM_FAILURE";
